export default __webpack_public_path__ + "static/media/thumb_4.be21df69.webp";